/**
 *
 * ShopServiceApiVersion
 *
 * @namespace ShopServiceApiVersion
 */
let ShopServiceApiVersion = function(){
    'use strict';

    let availablePaymentTypeServiceVersion = "v1";
    let deliveryTimeSlotServiceVersion = "v1";
    let errorMappingServiceVersion = "v1";
    let orderServiceVersion = "v1";
    let paymentServiceVersion = "v1";
    let postalCodeServiceVersion = "v1";
    let productServiceVersion = "v1";
    let sapOrderServiceVersion = "v1";
    let sapAdrServiceVersion = "v1";
    let sapAdrShipImmediateServiceVersion = "v1";
    let shippingServiceVersion = "v1";
    let waitingRoomServiceVersion = "v1";

    // ---------------------------------------------
    //
    //        Define all public methods.
    //
    // ---------------------------------------------
    let publicMethods = {
        /**
         * getAvailablePaymentTypeServiceVersionedUrl
         * @memberof ShopServiceApiVersion
         * @example
         * ShopServiceApiVersion.getAvailablePaymentTypeServiceVersionedUrl(url)
         * @param {string} url
         * @returns {string} url
         */
        getAvailablePaymentTypeServiceVersionedUrl : function(url){
            return getVersionedUrl (url, availablePaymentTypeServiceVersion);
        },
        /**
         * getDeliveryTimeSlotServiceVersionedUrl
         * @memberof ShopServiceApiVersion
         * @example
         * ShopServiceApiVersion.getDeliveryTimeSlotServiceVersionedUrl(url)
         * @param {string} url
         * @returns {string} url
         */
        getDeliveryTimeSlotServiceVersionedUrl : function(url){
            return getVersionedUrl (url, deliveryTimeSlotServiceVersion);
        },
        /**
         * getErrorMappingServiceVersionedUrl
         * @memberof ShopServiceApiVersion
         * @example
         * ShopServiceApiVersion.getErrorMappingServiceVersionedUrl(url)
         * @param {string} url
         * @returns {string} url
         */
        getErrorMappingServiceVersionedUrl : function(url){
            return getVersionedUrl (url, errorMappingServiceVersion);
        },
        /**
         * getOrderServiceVersionedUrl
         * @memberof ShopServiceApiVersion
         * @example
         * ShopServiceApiVersion.getOrderServiceVersionedUrl(url)
         * @param {string} url
         * @returns {string} url
         */
        getOrderServiceVersionedUrl : function(url){
            return getVersionedUrl (url, orderServiceVersion);
        },
        /**
         * getPaymentServiceVersionedUrl
         * @memberof ShopServiceApiVersion
         * @example
         * ShopServiceApiVersion.getPaymentServiceVersionedUrl(url)
         * @param {string} url
         * @returns {string} url
         */
        getPaymentServiceVersionedUrl : function(url){
            return getVersionedUrl (url, paymentServiceVersion);
        },
        /**
         * getPostalCodeServiceVersionedUrl
         * @memberof ShopServiceApiVersion
         * @example
         * ShopServiceApiVersion.getPostalCodeServiceVersionedUrl(url)
         * @param {string} url
         * @returns {string} url
         */
        getPostalCodeServiceVersionedUrl : function(url){
            return getVersionedUrl (url, postalCodeServiceVersion);
        },
        /**
         * getProductCodeServiceVersionedUrl
         * @memberof ShopServiceApiVersion
         * @example
         * ShopServiceApiVersion.getProductCodeServiceVersionedUrl(url)
         * @param {string} url
         * @returns {string} url
         */
        getProductCodeServiceVersionedUrl : function(url){
            return getVersionedUrl (url, productServiceVersion);
        },
        /**
         * getSapAdrServiceVersionedUrl
         * @memberof ShopServiceApiVersion
         * @example
         * ShopServiceApiVersion.getSapAdrServiceVersionedUrl(url)
         * @param {string} url
         * @returns {string} url
         */
        getSapAdrServiceVersionedUrl : function(url){
            return getVersionedUrl (url, sapAdrServiceVersion);
        },
        /**
         * getSapAdrShipImmediateVersionedUrl
         * @memberof ShopServiceApiVersion
         * @example
         * ShopServiceApiVersion.getSapAdrShipImmediateVersionedUrl(url)
         * @param {string} url
         * @returns {string} url
         */
        getSapAdrShipImmediateVersionedUrl : function(url){
            return getVersionedUrl (url, sapAdrShipImmediateServiceVersion);
        },
        /**
         * getSapOrderServiceVersionedUrl
         * @memberof ShopServiceApiVersion
         * @example
         * ShopServiceApiVersion.getSapOrderServiceVersionedUrl(url)
         * @param {string} url
         * @returns {string} url
         */
        getSapOrderServiceVersionedUrl : function(url){
            return getVersionedUrl (url, sapOrderServiceVersion);
        },
        /**
         * getShippingServiceVersionedUrl
         * @memberof ShopServiceApiVersion
         * @example
         * ShopServiceApiVersion.getShippingServiceVersionedUrl(url)
         * @param {string} url
         * @returns {string} url
         */
        getShippingServiceVersionedUrl : function(url){
            return getVersionedUrl (url, shippingServiceVersion);
        },
        /**
         * getWaitingRoomServiceVersionedUrl
         * @memberof ShopServiceApiVersion
         * @example
         * ShopServiceApiVersion.getWaitingRoomServiceVersionedUrl(url)
         * @param {string} url
         * @returns {string} url
         */
        getWaitingRoomServiceVersionedUrl : function(url){
            return getVersionedUrl (url, waitingRoomServiceVersion);
        }
    };

    // ---------------------------------------------
    //
    //        Define all private methods.
    //
    // ---------------------------------------------
    function getVersionedUrl (url, version){
        let versionedUrl = url;
        if (url && url.indexOf('{0}') !== -1){
            versionedUrl = url.replace("{0}", version);
        }
        return versionedUrl;
    }

    return publicMethods;
}();

export default ShopServiceApiVersion;
